import React from 'react';

import { MembersContextProvider } from '../members-context';
import { PredictionsInfoContext } from '../../forecast/detail/context/predictions-info-context';
import { DocumentLibrary } from '../components/document-library/document-library';

export const DocumentLibraryContainer = () => {
  return (
    <PredictionsInfoContext>
      <MembersContextProvider>
        <DocumentLibrary />
      </MembersContextProvider>
    </PredictionsInfoContext>
  );
};
